import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";
import { BargeType } from "__generated__/enums";
import { GetShipBayPlanTemplatesDocument, GetShipBayPlanTemplatesQuery } from "__generated__/view/ships/graphql/ship.queries.generated";

export type ShipBayPlanTemplateSelectOption = ChildPropsFromArray<GetShipBayPlanTemplatesQuery, "shipBayPlanTemplates">;

const ShipBayPlanTemplateSelect = ({
	value,
	onChange,
	rows,
	bays,
	tiers,
}: Omit<SelectProps<ShipBayPlanTemplateSelectOption, false>, "fetchOptions"> & {
	rows: number;
	bays: number;
	tiers: number;
}) => {

	const client = useApolloClient();

	const onFetchOptions = async(params: string) => {

		try  {
			const result = await client.query({
				query: GetShipBayPlanTemplatesDocument,
				variables: {
					search: {
						name: params,
						shipBargeType: BargeType.ContainerShip,
						tiers: tiers,
						rows: rows,
						bays: bays,
					},
				},
			});

			const options = result.data.shipBayPlanTemplates;

			return {
				options: options,
				totalResults: options.length,
			};

		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			value={value}
			onChange={onChange} />
	);
};

export default ShipBayPlanTemplateSelect;
